import { render } from "./App.vue?vue&type=template&id=68f4e35e&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=68f4e35e&lang=css"
import "./App.vue?vue&type=style&index=1&id=68f4e35e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68f4e35e"]])

export default __exports__